















































import { TableColumn } from "../../models/UI/TableColumn";
import moment from "moment";

export default {
    name: "TableSort",
    props: {
        columns: Array,
    },
    data() {
        return {
            selectedSorts: [],
            sortToAdd: null,
            ColumnType: TableColumn.ColumnType,
            SortOrder: TableColumn.SortOrder,
        };
    },
    created() {
        let self = this;
        _.filter(self.columns, { default_sort: true }).forEach(function (col) {
            self.sortToAdd = col;
            self.sortOrder = col.default_value;
            self.addSort();
        });
    },
    methods: {
        availableColumns(): Array<any> {
            let self = this;
            return _.filter(self.columns, function (c) {
                if (!c.sort_field) {
                    return false;
                }
                return !_.some(self.selectedSorts, { fieldName: c.sort_field });
            });
        },
        addSort(): void {
            let newSort = {
                fieldName: this.sortToAdd.sort_field,
                sortOrder: this.sortOrder || TableColumn.SortOrder.asc,
                name: this.sortToAdd.name,
            };
            this.selectedSorts.push(newSort);
            this.sortToAdd = null;
        },
        removeSort(sort): void {
            _.pull(this.selectedSorts, sort);
            this.onSortUpdate();
            this.$forceUpdate();
        },
        toggleSort(sort): void {
            if (sort.sortOrder === TableColumn.SortOrder.asc) {
                sort.sortOrder = TableColumn.SortOrder.desc;
            } else {
                sort.sortOrder = TableColumn.SortOrder.asc;
            }
            this.onSortUpdate();
        },
        // Events
        onSortUpdate(): void {
            let sort = _.chain(this.selectedSorts)
                .map(function (s) {
                    return s.fieldName + "#" + s.sortOrder;
                })
                .join(",")
                .value();
            this.$emit("update-sort", sort);
        },
    },
    computed: {},
    watch: {
        selectedSorts: {
            deep: true,
            handler: function () {
                this.onSortUpdate();
            },
        },
        sortToAdd: {
            deep: true,
            handler: function () {
                if (!_.isNull(this.sortToAdd)) {
                    this.addSort();
                }
            },
        },
    },
};
